// Shared helpers to recognise vehicle-type custody items (linked to employee vehicle_number).
export const VEHICLE_TYPE_HINTS = ["دراجة", "دباب", "سيارة", "مركبة", "مركبه", "شاحنة", "عربة", "vehicle", "car", "bike"];

export const CAR_CLASS_HINTS = ["خاصة", "خاصه", "أجرة", "اجرة", "أجره", "اجره", "نقل"];
export const DEFAULT_VEHICLE_TYPES = ["دراجة نارية", "سيارة", "خاصة", "أجرة", "نقل", "نقل عام"];
const CUSTOM = new Set();
let ALL = [...DEFAULT_VEHICLE_TYPES];
export const registerVehicleTypes = (names = []) => {
  CUSTOM.clear();
  names.forEach((x) => CUSTOM.add(String(x).trim().toLowerCase()));
  ALL = Array.from(new Set([...DEFAULT_VEHICLE_TYPES, ...names]));
};
export const getVehicleTypes = () => ALL;

export const isVehicleType = (name) => {
  const n = String(name || "").trim().toLowerCase();
  return [...VEHICLE_TYPE_HINTS, ...CAR_CLASS_HINTS].some((h) => n.includes(h.toLowerCase())) || (!!n && CUSTOM.has(n));
};

export const vehicleTypeLabel = (name) => {
  const n = String(name || "");
  if (n.includes("دراجة") || n.includes("دباب") || n.toLowerCase().includes("bike")) return "دراجة نارية";
  if (n.includes("سيارة") || n.toLowerCase().includes("car") || CAR_CLASS_HINTS.some((h) => n.includes(h)) || CUSTOM.has(n.trim().toLowerCase())) return "سيارة";
  return "";
};
